import React from 'react';

import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';

import { SurveyBlockContainerProps } from './types';

const SurveyBlockContainer: React.FC<React.PropsWithChildren<SurveyBlockContainerProps>> = (
  props,
) => {
  const { children, className, classes, isSelected, onSelect } = props;

  return (
    <>
      <Box
        className={cn(
          'relative my-4 flex-1 overflow-hidden rounded border border-solid border-border bg-bg-primary p-24 ps-32 pe-14 hover:shadow-01 min-h-[10rem]',
          { 'shadow-01': isSelected },
          className,
        )}
        onClick={onSelect}
        onFocus={onSelect}>
        <Box
          className={cn(
            'absolute top-20 bottom-20 start-16 w-4 rounded-full',
            isSelected ? classes?.focus?.focusIndicator ?? 'bg-interactive-primary' : '',
          )}
        />
        <Box>{children}</Box>
      </Box>
    </>
  );
};

export default React.memo(SurveyBlockContainer);
